<template>
  <template v-if="store.queryStatus == 'ready' && store.totalNumberOfResults > store.query.resultsPerPage">
    <ul class="pagination">
      <li
        class="page-item"
        :class="{ disabled: store.query.pageNumber <= 1 }"
      >
        <button
          type="button"
          class="page-link"
          tabindex="-1"
          @click="updatePageNumber(store.query.pageNumber - 1)"
          :disabled="store.query.pageNumber <= 1"
        >
          {{ previousLabel }}
        </button>
      </li>
      <template
        v-for="pageNumber in pageNumbers"
        :key="pageNumber"
      >
        <li
          v-if="pageNumber == store.query.pageNumber"
          class="page-item active"
        >
          <span class="page-link">
            {{ pageNumber }}
          </span>
        </li>
        <li
          v-else-if="pageNumber <= startCount || pageNumber >= (pageCount - endCount + 1) || (Math.abs(pageNumber - store.query.pageNumber) <= adjacentCount)"
          class="page-item"
          :class="{ active: store.query.pageNumber == pageNumber }"
        >
          <button type="button" class="page-link" @click="updatePageNumber(pageNumber)">
            {{ pageNumber }}
          </button>
        </li>
        <li
          v-else-if="(pageNumber == (startCount + 1) && store.query.pageNumber > startCount + 1 + adjacentCount) || (pageNumber == (pageCount - endCount) && store.query.pageNumber < (pageCount - endCount - adjacentCount))"
          class="page-item disabled"
        >
          <span class="page-link">
            ...
          </span>
        </li>
      </template>
      <li
        class="page-item"
        :class="{ disabled: store.query.pageNumber >= pageCount }"
      >
        <button
          type="button"
          class="page-link"
          tabindex="-1"
          @click="updatePageNumber(store.query.pageNumber + 1)"
          :disabled="store.query.pageNumber >= pageCount"
        >
          {{ nextLabel }}
        </button>
      </li>
    </ul>
  </template>
</template>

<script>
import { PhysiciansStore } from '../stores/PhysiciansStore'
import { SearchStore } from '../stores/SearchStore'

export default {
  props: {
    storeName: {
      type: String,
      required: true
    },
    previousLabel: {
      type: String,
      required: true
    },
    nextLabel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      startCount: 2,
      endCount: 2,
      adjacentCount: 2
    }
  },
  computed: {
    pageNumbers() {
      return Array.from({ length: this.pageCount }, (v, k) => k + 1)
    },
    pageCount() {
      return Math.ceil(this.store.totalNumberOfResults / this.store.query.resultsPerPage)
    }
  },
  watch: {
  },
  setup(props) {
    let store

    switch (props.storeName)
    {
      case 'physicians':
        store = PhysiciansStore()
        break
      default:
        store = SearchStore()
        break
    }

    return {
      store
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    updatePageNumber(pageNumber) {
      this.store.updatePageNumber(pageNumber)
    }
  },
  components: {
  }
}
</script>